import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link, Redirect } from 'react-router-dom';
import './SignIn.css';
import Button from '../../components/Button';
import Logo from '../../components/Logo';
import loginFields from '../../forms/member/login';
import { extractPhasesOrFail } from '../../helpers/ValueBuilder';
import adminActions from '../../actions/admin';
import formHelpers from '../../helpers/FormHelpers';
import rememberMeFields from '../../forms/member/rememberMe';



class SignIn extends Component {
  constructor() {
    super();
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleLoginClick = this.handleLoginClick.bind(this);
    this.handleFieldBlur = this.handleFieldBlur.bind(this);
    this.handleEnter = this.handleEnter.bind(this);
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleFieldFocus = this.handleFieldFocus.bind(this);
  }

  componentWillMount() {
    this.setState({
      fields: loginFields,
      rememberMeFields
    })
  }

  handleCheckboxClick(name, value) {
    formHelpers.handleCheckboxClick(value, name, 'rememberMeFields', this);
  }

  handleFieldBlur(name) {
    formHelpers.handleFieldBlur(name, 'fields', this);
  }

  handleFieldChange(value, name) {
    formHelpers.handleFieldChange(value, name, 'fields', this);
  }

  handleFieldFocus(name) {
    formHelpers.handleFieldFocus(name, 'fields', this);
  }

  handleEnter(e) {
    e.preventDefault();
    this.handleLoginClick();
  }

  handleLoginClick() {
    const { fields } = this.state;
    let data = extractPhasesOrFail({ fields });
    if (data) {
      this.props.dispatch(adminActions.login(data));
    } else {
      this.setState({
        fields: formHelpers.blurphase(fields)
      })
    }
  }

  render() {
    const { fields, rememberMeFields } = this.state;
    const { admin, location } = this.props;
    const { from } = location.state || { from: { pathname: '/' } }

    if (admin.data && admin.data.apikey) {
      return (<Redirect to={from} />)
    }
    return (
      <div className="saga-wrap">
        <div className="saga">
          <form className="signin__form" onSubmit={this.handleEnter}>
						<Logo />
						<p className="signin__prompt">
							Sign in
						</p>
            { formHelpers.buildFields(fields, this) }
            <div className="clear"></div>
						<Link to="/forgot-password" className="signin__forgot simple-link">
              Forget your password?
						</Link>
            <div className="clear"></div>
            <Button
              text="Sign In"
              allowHover={true}
              center={true}
							makeFull={true}
              type="submit"
              onClick={() => {}}/>
            <div className="clear"></div>
          </form>
          <div className="clear"></div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(
  (state) => ({
    member: state.member,
    points: state.points,
    admin: state.admin
  })
)(SignIn));



/** WEBPACK FOOTER **
 ** ./src/containers/SignIn/index.js
 **/